import { render, staticRenderFns } from "./bussgrid.vue?vue&type=template&id=2262fa42"
import script from "./bussgrid.vue?vue&type=script&lang=js"
export * from "./bussgrid.vue?vue&type=script&lang=js"
import style0 from "./bussgrid.vue?vue&type=style&index=0&id=2262fa42&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports